<div class="card">
  <div class="card-body">
    <h5 class="mt-4">
      {{ 'Common.SubscriptionComplete' | labelText }}
    </h5>
  </div>
</div>
